module.exports = __webpack_public_path__ + "img/5.64de9275.png";